import { render, staticRenderFns } from "./PNRXml.vue?vue&type=template&id=6c5cb5ca&"
import script from "./PNRXml.vue?vue&type=script&lang=js&"
export * from "./PNRXml.vue?vue&type=script&lang=js&"
import style0 from "./PNRXml.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports